import Vue from 'vue'
import Vuex from 'vuex'
import { Howl, Howler } from 'howler'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    numScenes: 13,
    currentScene: 1,
    beginButton: true,
    muted: false,
    trackTime: 0,
    trackInterval: null,
    audio: {
      scene1: new Howl({
        src: ['audio/stream1.mp3']
      }),
      scene2: new Howl({
        src: ['audio/stream2.mp3']
      }),
      scene3: new Howl({
        src: ['audio/stream3.mp3']
      }),
      scene4: new Howl({
        src: ['audio/stream4.mp3']
      }),
      scene5: new Howl({
        src: ['audio/stream5.mp3']
      }),
      scene6: new Howl({
        src: ['audio/stream6.mp3']
      }),
      scene7: new Howl({
        src: ['audio/stream7.mp3']
      }),
      scene8: new Howl({
        src: ['audio/stream8.mp3']
      }),
      scene9: new Howl({
        src: ['audio/stream9.mp3']
      }),
      scene10: new Howl({
        src: ['audio/stream10.mp3']
      }),
      scene11: new Howl({
        src: ['audio/stream11.mp3']
      }),
      scene12: new Howl({
        src: ['audio/stream12.mp3']
      }),
      scene13: new Howl({
        src: ['audio/stream13.mp3']
      }),
    }
  },
  mutations: {
    SET_CURRENT_SCENE (state, payload) {
      state.currentScene = payload
    },
    PREVIOUS_SCENE (state) {
      state.currentScene--
    },
    PREVIOUS_TWO_SCENES (state) {
      state.currentScene--
      state.currentScene--
    },
    NEXT_SCENE (state) {
      state.currentScene++
    },
    NEXT_TWO_SCENES (state) {
      state.currentScene++
      state.currentScene++
    },
    HIDE_BEGIN_BUTTON (state) {
      state.beginButton = false
    },
    MUTE (state) {
      state.muted = true
    },
    UNMUTE (state) {
      state.muted = false
    },
    RESET_TRACK_TIME (state) {
      state.trackTime = 0
    },
    RESET_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
      state.trackInterval = setInterval(() => {
        state.trackTime += 0.1
      }, 100)
    },
    CLEAR_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
    }
  },
  actions: {
    begin ({ commit, dispatch }) {
      commit('HIDE_BEGIN_BUTTON')
      dispatch('playAudioByScene')
    },
    previousScene ({ state, commit, dispatch }) {
      if (state.currentScene > 1) {
        commit('PREVIOUS_SCENE')
      }
      dispatch('playAudioByScene')
    },
    previous2Scenes ({ state, commit, dispatch }) {
      if (state.currentScene > 2) {
        commit('PREVIOUS_TWO_SCENES')
      }
      dispatch('playAudioByScene')
    },
    nextScene ({ state, commit, dispatch }) {
      if (state.currentScene < state.numScenes) {
        commit('NEXT_SCENE')
      } else {
        if (window.history.length > 1) {
          window.history.go(-1)
        } else {
          commit('SET_CURRENT_SCENE', 1)
        }
      }
      dispatch('playAudioByScene')
    },
    next2Scenes ({ state, commit, dispatch }) {
      if (state.currentScene+1 < state.numScenes) {
        commit('NEXT_TWO_SCENES')
      } else {
        if (window.history.length > 1) {
          window.history.go(-1)
        } else {
          commit('SET_CURRENT_SCENE', 1)
        }
      }
      dispatch('playAudioByScene')
    },
    toggleMute ({ state, commit }) {
      if (state.muted) {
        Howler.mute(false)
        commit('UNMUTE')
      } else {
        Howler.mute(true)
        commit('MUTE')
      }
    },
    stopAllAudio ({ state, commit }) {
      Object.keys(state.audio).forEach((key) => {
        state.audio[key].stop()
      })
      commit('CLEAR_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
    },
    playAudioByScene ({ state, commit, dispatch }) {
      dispatch('stopAllAudio')
      if (typeof state.audio[`scene${state.currentScene}`] !== 'undefined') {
        state.audio[`scene${state.currentScene}`].play()
        commit('RESET_TRACK_INTERVAL')
        commit('RESET_TRACK_TIME')
      }
    },
    playAudioByName ({ state }, name) {
      if (typeof state.audio[name] !== 'undefined') {
        state.audio[name].play()
      }
    }
  }
})

export default store
